import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { toFullName } from '@repo/toolkit/to-full-name'
import Badge from '@repo/ui/badge'
import { UserTwoIcon } from '@repo/ui/icons'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'

import CountryFlag from '../../../components/elements/country-flag'
import ClientEnrollmentProfileCard from '../../../components/pages/client-space/home/client-enrollment-profile-card'
import ClientEnrollmentProgressCard from '../../../components/pages/client-space/home/client-enrollment-progress-card'
import EnrollmentProfileGlobalView from '../../../components/pages/enrollment-profile/enrollment-profile-global-view'
import useEnrollment from '../../../lib/hooks/use-enrollment'
import { EnrollmentProperties } from '../../../lib/types/models/enrollment/enrollment.properties'

const ClientHomePage = () => {
  const { enrollment } = useEnrollment()

  return (
    <div className="flex flex-col gap-4">
      <ClientEnrollmentProgressCard data={enrollment} />
      <ClientEnrollmentProfileCard enrollment={enrollment}>
        <div className="flex flex-col gap-2.5">
          <Typography variant="text" color={tailwindColors.black.DEFAULT}>
            {toFullName(enrollment.childFirstName, enrollment.childLastName)}
          </Typography>
          <div className="p-2 rounded border border-grey-light bg-white-hover flex items-center gap-2">
            <CountryFlag code={EnrollmentProperties.getEnrollmentCountry(enrollment).value} />
            <Typography variant="label-semibold">
              {EnrollmentProperties.getEnrollmentLabel(enrollment)}
            </Typography>
          </div>
        </div>
      </ClientEnrollmentProfileCard>
      <InnerBox className="rounded-lg p-4">
        <div className="flex items-center gap-1.5">
          <Badge
            icon={<UserTwoIcon color={tailwindColors.primary.DEFAULT} />}
            variant="primary"
            size="flexible"
          />
          <Typography variant="text" color={tailwindColors.black.DEFAULT}>
            Profil du participant
          </Typography>
        </div>
        <div className="h-4" />
        <EnrollmentProfileGlobalView mode="parent" />
      </InnerBox>
    </div>
  )
}

export default ClientHomePage
